<script setup lang="ts">
import { computed, provide, watch } from "vue";
import { nameInjectionKey } from "../keys";
import useVuelidate, { ValidationArgs } from "@vuelidate/core";

const props = withDefaults(defineProps<{
    name: string,
    validation?: ValidationArgs,
    values: Record<string, unknown>,
    class?: string,
}>(), {
    validation: undefined,
    class: "alert alert-danger",
});

provide(nameInjectionKey, props.name);

const v$ = useVuelidate({
    field: props.validation ?? {},
}, {
    field: computed(() => null),
});

watch(() => props.values, () => {
    v$.value.$validate();
});

</script>

<template>
    <div
        v-if="v$.$error"
    >
        <div :class="props.class">
            {{ v$.$errors[0].$message }}
        </div>
    </div>
</template>
